import { render, staticRenderFns } from "./add_index.vue?vue&type=template&id=30f0bbc6&scoped=true"
import script from "./add_index.vue?vue&type=script&lang=js"
export * from "./add_index.vue?vue&type=script&lang=js"
import style0 from "./add_index.vue?vue&type=style&index=0&id=30f0bbc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f0bbc6",
  null
  
)

export default component.exports